import Link from "components/common/Link";
import TagItem from "components/common/TagItem";
import * as routePath from "shared/constants/RoutePathConstants";

interface Props {
  tagItems: string[];
  onChange?: (items: string[]) => void;
  selectedItems?: string[];
}

export default function ActionSummaryTagFilter(props: Props) {
  const { tagItems, selectedItems, onChange } = props;

  const isSelectedTag = (tagItem: string) => {
    return !!(selectedItems || []).find((tag) => tag === tagItem);
  };

  const handleTagSelectionChange = (tagItem: string) => {
    let items = [];

    if (selectedItems) {
      const isAlreadyInSelection = isSelectedTag(tagItem);
      if (isAlreadyInSelection) {
        items = selectedItems.filter((item) => item !== tagItem);
      } else {
        items = [...selectedItems, tagItem];
      }
    } else {
      items.push(tagItem);
    }

    onChange?.(items);
  };

  return (
    <div className="space-x-1">
      {tagItems.map((tag, index) => {
        return (
          <TagItem
            key={index}
            text={tag}
            isSelected={isSelectedTag(tag)}
            selectable={true}
            onSelect={() => handleTagSelectionChange(tag)}
          />
        );
      })}
      {!tagItems.length && (
        <span className="text-promGray2">
          No tags (set tags in{" "}
          <Link className="font-bold" to={routePath.TOKENS}>
            token page
          </Link>
          )
        </span>
      )}
    </div>
  );
}
